export default __webpack_public_path__ + "static/media/home_players_update.c99ea932.png";